/**
 *
 *
 */
export type PromiseOptions = {
  /**
 *
 *
 *
 */
  timeout?: number;
  /**
 *
 *
 */
  signal?: AbortSignal;

  /**
 *
 *
 */
  message?: string;
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const withPromise = (
  promise: Promise<unknown>,
  options: PromiseOptions,
): Promise<unknown> => {
  const { timeout, signal, message = "Promise resolution failed" } = options;
  const races: Promise<unknown>[] = [promise];

  if (timeout) {
    races.push(
      new Promise((_, reject) => {
        setTimeout(() => {
          reject(Error(`${message}. Wait exceeded configured timeout: ${timeout}`));
        }, timeout);
      }),
    );
  }

  if (signal) {
    races.push(
      new Promise((_, reject) => {
        signal.addEventListener("abort", () => {
          reject(Error(`${message}. Wait cancelled due to abort signal: ${signal.reason}`));
        });
      }),
    );
  }

  return Promise.race(races);
};
